export class LoadFixer {
    public static LOAD_ERRORS: any[] = [];
}